import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType, StatusCode } from "api/protocols";
import { CancelToken } from "axios";
import { TFacilityForm } from "redux/reducers/models/facility";

type GetFacilityFormParams = {
  id?: number;
  variant_ids?: number[];
};

export type PostFacilityFormParams = {
  title: string;
  process_product_with_response?: boolean;
};

export type PutFacilityFormParams = {
  id: number;
  title?: string;
  process_product_with_response?: boolean;
};

type DeleteFacilityFormParams = {
  id: number;
};

interface IFacilityFormRes<T> {
  status: StatusCode;
  data: T;
  message?: string;
}

// GET Forms
export async function GetFacilityForm(
  params: GetFacilityFormParams,
  useGlobalLoader = true,
  token?: CancelToken,
): Promise<IFacilityFormRes<TFacilityForm[]>> {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/client/form"), params, useGlobalLoader, token);
}

// POST Form
export async function PostFacilityForm(
  params: PostFacilityFormParams,
  useGlobalLoader = true,
): Promise<IFacilityFormRes<TFacilityForm>> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/client/form"), params, useGlobalLoader);
}

// PUT Forms
export async function PutFacilityForm(
  params: PutFacilityFormParams,
  useGlobalLoader = true,
): Promise<IFacilityFormRes<PutFacilityFormParams>> {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/form"), params, useGlobalLoader);
}

// PUT Forms
export async function DeleteFacilityForm(
  params: DeleteFacilityFormParams,
  useGlobalLoader = true,
): Promise<IFacilityFormRes<DeleteFacilityFormParams>> {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/client/form"), params, useGlobalLoader);
}

export async function AddFormToVariant(params: any, useGlobalLoader: true) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/form/variant"), params, useGlobalLoader);
}
